import axios from 'axios';
import config from './config';
const appAxios = axios.create({
    baseURL: config.externalAppsUrl,
});

class ApiExternalApp {
    static async getExternalApps() {
        return new Promise(function (resolve, reject) {
            appAxios.get("").then(function (response) {
                    if (response.status === 200) {
                        resolve({ data: response.data, keys: Object.keys(response.data) });
                    } else {
                        resolve({ data: {}, keys: [] });
                    }
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    static openApp(value , data) {
        return new Promise(async function (resolve, reject) {
            appAxios.post( `/${value}`, data, {
                headers: {
                    "Content-Type": "application/json",
                },
            }).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    }
}
export default ApiExternalApp;